import { Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { AssinaturaDto, PlanoBeneficiosDto, PlanoDto } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'exibir-plano',
  templateUrl: './exibir-plano.component.html',
  styleUrls: ['./exibir-plano.component.scss']
})
export class ExibirPlanoComponent extends AppComponentBase {
  @Input() plano: PlanoDto;
  @Input() assinaturaAnual: boolean = false;
  @Input() planoAtual: PlanoDto;
  @Input() isAnual: boolean = true;
  @Input() showOptions: boolean = true;
  @Input() assinatura: AssinaturaDto;
  @Output() onSelected = new EventEmitter<PlanoDto>;

  constructor(injector: Injector) { super(injector) }

  protected selecionarPlano(plano: PlanoDto): void {
    this.onSelected.emit(plano);
  }
  protected showAtualizarPlano(): boolean {
    if (!this.planoAtual && this.showOptions) return true;
    if (!this.showOptions) return false;

    const planoNaoSelecionado = !this.planoAtual;
    const planoDiferente = this.plano.id !== this.planoAtual?.id;
    const tipoAssinaturaAlterado = this.plano.id === this.planoAtual?.id && this.assinaturaAnual !== this.isAnual;
    const assinaturaCancelada = this.assinatura.status === 'cancelled';

    return planoNaoSelecionado || planoDiferente || tipoAssinaturaAlterado || assinaturaCancelada;
  }

  protected showPlanoAtual(): boolean {
    if (!this.showOptions || !this.planoAtual) return false;

    const mesmoPlano = this.plano.id === this.planoAtual.id;
    const mesmoTipoAssinatura = this.assinaturaAnual === this.isAnual;
    const assinaturaAtiva = this.assinatura.status !== 'cancelled';

    return mesmoPlano && mesmoTipoAssinatura && assinaturaAtiva;
  }

  protected getBeneficios(): string[] {
    const beneficios = this.plano.planoBeneficios.map(x => x.descricao);

    if (beneficios.length <= 4) {
      return beneficios;
    }

    const primeirosBeneficios = beneficios.slice(0, 4);
    const quantidadeRestante = beneficios.length - 4;

    return [...primeirosBeneficios, `+${quantidadeRestante} benefícios`];
  }
}
